export enum AssetDeleteStatus {
    NONE = 'none',
    LOADING = 'loading',
    ERROR = 'error',
    SUCCESS = 'success',
}
